import React from "react";

import { Control, FieldErrors, UseFormWatch } from "react-hook-form";

import { useRegisterFormContext } from "@pages/register/hooks/useRegisterFormContext";

import { UserDetailsInput, UserInput } from "../RegisterFormTypes";

import { AccountDetails } from "./AccountDetails";
import { BankDetails } from "./BankDetails";
import { BusinessTaxDetails } from "./BusinessTaxDetails";
import { ContactDetails } from "./ContactDetails";
import { FinanceContactInformation } from "./FinanceContactInformation";

export type accordionItemsType = {
  key: keyof UserDetailsInput;
  header: string;
  Component: React.ComponentType<AccordionFormProps>;
  AdditionalProps?: object;
};

export const accordionItems = (isCreatedUserCompletingRegistration: boolean): accordionItemsType[] => [
  {
    key: "contact_details",
    header: "Contact details",
    Component: ContactDetails,
    AdditionalProps: { isCreatedUserCompletingRegistration },
  },
  {
    key: "tax_details",
    header: "Business & tax details",
    Component: BusinessTaxDetails,
    AdditionalProps: { isCreatedUserCompletingRegistration },
  },
  {
    key: "account_details",
    header: "Account details",
    Component: AccountDetails,
  },
  {
    key: "finance_contact",
    header: "Invoice contact information",
    Component: FinanceContactInformation,
  },
  {
    key: "bank_details",
    header: "Bank details",
    Component: BankDetails,
  },
];

export interface AccordionFormProps {
  control: Control<UserDetailsInput>;
  errors: FieldErrors<UserDetailsInput>;
  multiFormData: UserInput;
  watch: UseFormWatch<UserDetailsInput>;
  onCheckboxChange?: (checked: boolean) => void;
  isJoiningExistingAccount?: boolean;
  isAmp: boolean;
  isCreatedUserCompletingRegistration?: boolean;
}

interface AccordionItemProps {
  Component: React.ComponentType<AccordionFormProps>;
  AdditionalProps?: object;
}

export const AccordionItem = ({ Component, AdditionalProps }: AccordionItemProps) => {
  const context = useRegisterFormContext();

  return <Component {...context} {...AdditionalProps} />;
};
